import Avatar from "@/components/Avatar";

/**
 * Forum-specific avatar. Renders either:
 *  - the author's picture (delegates to universal <Avatar>), OR
 *  - just the first initial on a neutral background (lighter-weight, more private-feeling)
 *
 * Keeps the forum palette distinct from the teal brand Avatar used elsewhere.
 */
export default function ForumAvatar({ post, size = "md" }) {
  const sizeClass = {
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-12 h-12 text-base",
  }[size];

  const mode = post?.author_avatar_mode;
  const url = post?.author_avatar_url;
  const initial = post?.author_initial || "?";

  if (mode === "picture" && url) {
    return <Avatar src={url} name={post.author_display_name} size={size === "md" ? "md" : size === "sm" ? "sm" : "md"} data-testid="forum-avatar-img" />;
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-accent text-foreground font-semibold flex items-center justify-center border border-border shrink-0`}
      data-testid="forum-avatar-initial"
    >
      {initial}
    </div>
  );
}
